import React, { Component } from "react";
import { connect } from "react-redux";
import Parse from "parse";

import Header from "./Header";
import MessageList from "./MessageList/MessageList";
import UserInput from "./UserInput";
import {
  convertParseObjectsToMessages,
  getChatFileType,
  toBase64,
} from "../../helpers";

import "./style.scss";

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatInitialized: false,
      messageList: [],
      userData: props.user || {},
    };
  }

  componentDidMount() {
    const { chatInitialized } = this.state;

    if (!chatInitialized) {
      this.initializeChatConnection();
    }
  }

  initializeChatConnection = async () => {
    const { userData, id, user } = this.props;
    Parse.serverURL = window.env.PARSE_SERVER_URL;
    Parse.initialize("splus", "net.masterworks.apps.splus");
    const Message = Parse.Object.extend("Message");
    const query = new Parse.Query(Message)
      .equalTo("project", `${id}`)
      .descending("createdAt");
    let results = await query.find();
    results = results.reverse();

    this.setState({
      messageList: convertParseObjectsToMessages(
        results,
        user?.UserName ? user.UserName : ""
      ),
      chatInitialized: true,
    });

    const messagesSubscription = await query.subscribe();
    messagesSubscription.on("create", (parseObject) => {
      this.setState((previousState) => {
        return {
          messageList: [
            ...previousState.messageList,
            ...convertParseObjectsToMessages(
              [parseObject],
              user?.UserName ? user.UserName : ""
            ),
          ],
        };
      });
    });
  };

  onMessageWasSent = async (message) => {
    const { user, id } = this.props;
    const Message = Parse.Object.extend("Message");
    const newMessage = new Message({
      ...message,
      creationDate: new Date().getTime(),
      body_text: message.data.text,
      sender_id: user.UserName,
      display_name: user.DisplayName,
      project: `${id}`,
      type: "TEXT",
    });
    newMessage.save();
  };

  onFilesSelected = (files) => {
    const { user, id } = this.props;
    Object.keys(files).forEach(async (key) => {
      const file = files[key];
      const base64 = await toBase64(file);
      const uploadedFile = await new Parse.File(file.name, {
        base64,
      }).save();

      const Message = Parse.Object.extend("Message");
      const messageObject = {
        creationDate: new Date().getTime(),
        sender_id: user.UserName,
        display_name: user.DisplayName,
        downloadUrl: uploadedFile._url,
        project: `${id}`,
        file_name: file.name,
        file_extension: getChatFileType(file.name),
      };
      let newMessage;
      if (file.type.startsWith("image")) {
        newMessage = new Message({
          ...messageObject,
          type: "IMAGE",
        });
      } else {
        newMessage = new Message({
          ...messageObject,
          type: file.type.startsWith("audio") ? "VOICE" : "FILE",
        });
      }
      newMessage.save();
    });
  };

  getData(data) {
    switch (data.type) {
      case "TEXT":
        return data.text;
      case "VOICE":
        return data.downloadUrl;
      case "IMAGE":
        return data.downloadUrl;
      default:
        return console.error(
          `Attempting to load message with unsupported file type '${data.type}'`
        );
    }
  }

  render() {
    const { theme, onClose, locale } = this.props;
    const { messageList } = this.state;

    return (
      <div className="chat-custom">
        <div className="chat-component" id="sc-launcher">
          <Header
            theme={theme}
            onClose={() => {
              onClose();
            }}
          />

          <MessageList messages={messageList} theme={theme} locale={locale} />
          <UserInput
            locale={locale}
            theme={theme}
            onSubmit={this.onMessageWasSent.bind(this)}
            onFilesSelected={this.onFilesSelected.bind(this)}
            showEmoji
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ theme, language, user }) => ({
  theme,
  locale: language.locale,
  user: user.user,
});

export default connect(mapStateToProps)(Chat);
